import {
  Box,
  CircularProgress,
  Divider,
  Stack,
  Typography,
} from "@mui/material";

import { ErrorTypography } from "components/ErrorTypography";
import { useShipmentQuotes } from "hooks";
import { sortQuotes } from "utils";

import { ShipmentQuote } from "../../../ShipmentQuote";

interface Props {
  shipment: CondensedShipment;
}

export function ShipmentQuoteList(props: Props) {
  const { shipment } = props;
  const {
    quotes,
    isLoading: loading,
    error,
  } = useShipmentQuotes(shipment.info.id);

  if (loading) {
    return (
      <Stack alignItems="center" p={4}>
        <CircularProgress />
      </Stack>
    );
  }

  if (error != null) {
    return (
      <Stack p={4}>
        <ErrorTypography error={error} />
      </Stack>
    );
  }

  if (quotes.length === 0) {
    return (
      <Typography variant="body1" textAlign="center" mt="1rem">
        You do not have any quotes on this shipment.
      </Typography>
    );
  }

  const sortedQuotes = sortQuotes(quotes);
  const hasMultipleQuotes = sortedQuotes.length > 1;

  return (
    <Stack divider={<Divider />}>
      {sortedQuotes.map((quote) => (
        <Box key={quote.quote}>
          <ShipmentQuote quote={quote} hasMultipleQuotes={hasMultipleQuotes} />
        </Box>
      ))}
    </Stack>
  );
}
